// English strings (source language): shared: buttons, units, plurals, ranks.

const suffix: Record<string, string> = { one: 'st', two: 'nd', few: 'rd', other: 'th' };
const s = (n: number) => (n === 1 ? '' : 's');

const en = {
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  save: 'Save',
  back: 'Back',
  delete: 'Delete',
  loading: 'Loading…',
  oops: 'Oops',
  error: 'Error',
  level: 'Level',
  levelShort: 'Lvl',
  you: 'You',
  /** Ordinal rank; `cat` is the Intl ordinal category (unused in French). */
  ordinal: (n: number, cat: string) => `${n}${suffix[cat] ?? 'th'}`,
  durHM: (h: number, mm: string) => `${h} h ${mm}`,
  durMS: (m: number, ss: string) => `${m} min ${ss} s`,
  durM: (m: number) => `${m} min`,
  durS: (x: number) => `${x} s`,
  rides: (n: number) => `${n} ride${s(n)}`,
  days: (n: number) => `${n} day${s(n)}`,
  riders: (n: number) => `${n} rider${s(n)}`,
  hits: (n: number) => `${n} hit${s(n)}`,
  workouts: (n: number) => `${n} workout${s(n)}`,
  weeks: (n: number) => `${n} week${s(n)}`,
  /** Line of earned XP, from the key provided by the core. */
  xp: {
    distance: (km: string) => `${km} km ridden`,
    effort: (min: number) => `${min} min of effort`,
    win: 'Win',
    podium: (rank: string) => `Podium (${rank})`,
    finished: 'Race finished',
    online: 'Online race',
    hits: (n: number) => `${n} hit${s(n)}`,
    workout: 'Workout completed',
    game: 'Game completed',
    test: 'FTP test',
    record: (time: string) => `Record beaten (${time})`,
    firstOfDay: 'First ride of the day',
    challenge: (name: string) => `Legendary challenge: ${name}`,
  },
};
export default en;
